import { MdOutlineHomeWork, MdOutlineCelebration, MdOutlineRestaurant } from "react-icons/md"

function ContactCTA() {
    return (
        <section className="bg-[#1B4D3E] py-24 px-6 mt-24">
            <div className="max-w-6xl mx-auto">
                <div className="text-center mb-16">
                    <p className="text-orange-500 text-xs uppercase tracking-[0.3em] mb-4 font-semibold">
                        We're Here to Help
                    </p>
                    <h2 className="font-serif text-4xl md:text-6xl text-white mb-6 leading-tight">
                        Expect a <span className="text-orange-500 italic">Personal Response</span>
                    </h2>
                    <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                        Whether you're inquiring about a furnished apartment, planning an event, or need
                        catering services, our team will get back to you within 24 hours with a personalized solution.
                    </p>
                </div>
                <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-16">
                    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center hover:bg-white/10 transition-all duration-300">
                        <div className="bg-orange-500/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                            <MdOutlineHomeWork className="h-7 w-7 text-orange-500" />
                        </div>
                        <h3 className="font-serif text-xl text-white mb-3">
                            Short & Long-Term Stays
                        </h3>
                        <p className="text-white/60 text-sm leading-relaxed">
                            We'll help you find the perfect furnished apartment that matches your needs and budget.
                        </p>
                    </div>
                    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center hover:bg-white/10 transition-all duration-300">
                        <div className="bg-orange-500/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                            <MdOutlineCelebration className="h-7 w-7 text-orange-500" />
                        </div>
                        <h3 className="font-serif text-xl text-white mb-3">
                            Event Planning
                        </h3>
                        <p className="text-white/60 text-sm leading-relaxed">
                            From venue setup to full coordination, we'll bring your vision to life with precision.
                        </p>
                    </div>
                    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center hover:bg-white/10 transition-all duration-300">
                        <div className="bg-orange-500/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                            <MdOutlineRestaurant className="h-7 w-7 text-orange-500" />
                        </div>
                        <h3 className="font-serif text-xl text-white mb-3">
                            Catering Services
                        </h3>
                        <p className="text-white/60 text-sm leading-relaxed">
                            Customized menus and professional service for any occasion, big or small.
                        </p>
                    </div>

                </div>
                <div className="border-t border-white/10 pt-12">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">

                        <div>
                            <div className="text-orange-500 text-3xl font-serif font-bold mb-2">24h</div>
                            <p className="text-white/60 text-xs uppercase tracking-widest">Response Time</p>
                        </div>

                        <div>
                            <div className="text-orange-500 text-3xl font-serif font-bold mb-2">13+</div>
                            <p className="text-white/60 text-xs uppercase tracking-widest">Properties Available</p>
                        </div>

                        <div>
                            <div className="text-orange-500 text-3xl font-serif font-bold mb-2">24/7</div>
                            <p className="text-white/60 text-xs uppercase tracking-widest">Customer Support</p>
                        </div>

                    </div>
                </div>
                <div className="mt-12 text-center">
                    <p className="text-white/60 text-sm mb-4">
                        Prefer to talk directly?
                    </p>
                    <div className="flex flex-col md:flex-row items-center justify-center gap-6">
                        <a
                            href="tel:+254711610000"
                            className="text-white hover:text-orange-500 transition-colors text-lg font-serif"
                        >
                            +254 711 610 000
                        </a>
                        <span className="text-white/30 hidden md:block">|</span>
                        <a
                            href="mailto:hello@sagecreations.co.ke"
                            className="text-white hover:text-orange-500 transition-colors text-lg font-serif"
                        >
                            hello@sagecreations.co.ke
                        </a>
                    </div>
                    <p className="text-white/40 text-xs mt-6 tracking-wide">
                        Based in Kisumu • Serving All of Kenya
                    </p>
                </div>

            </div>
        </section>
    )
}

export default ContactCTA